// extracted by mini-css-extract-plugin
module.exports = {"customButtonEdit":"styles_customButtonEdit__1MAkZ","modalRecall":"styles_modalRecall__3JpB1","fieldReason":"styles_fieldReason__22CxS"};